import { render, staticRenderFns } from "./openInstitutionServices.vue?vue&type=template&id=17062f7a&scoped=true&"
import script from "./openInstitutionServices.vue?vue&type=script&lang=js&"
export * from "./openInstitutionServices.vue?vue&type=script&lang=js&"
import style0 from "./openInstitutionServices.vue?vue&type=style&index=0&id=17062f7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17062f7a",
  null
  
)

export default component.exports